import emojiRegex from "emoji-regex"
import getFirstCharacter from './getFirstCharacter'

export default function stringStartsWithEmoji (string: string) {
  const firstCharacter = getFirstCharacter(string)
  if (firstCharacter === undefined) return false
  return emojiRegex().test(firstCharacter)
}
